export enum ClosureSubType {
  SchoolClosureEntity = 'closures_school-closure',
  RoadClosureEntity = 'closures_road-closure',
  FacilityOrParkClosureEntity = 'closures_facility-or-park-closure',
  ParkClosureEntity = 'closures_park-closure',
  GenericClosureEntity = 'closures_other',
}
